import { createAsyncThunk } from "@reduxjs/toolkit";
import { handleErrorResponse } from "../../apis";
import axios from "axios";

export const updateBoxSplitStatus = createAsyncThunk(
  "updateBoxSplitStatus",
  async (data, { rejectWithValue }) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/china/update-box-split-status`;
    try {
      const response = await axios.post(URL, data);
      return response;
    } catch (error) {
      return handleErrorResponse(error, rejectWithValue);
    }
  }
);

export const splittedBoxDetails = createAsyncThunk(
  "splittedBoxDetails",
  async (data, { rejectWithValue }) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/china/splitted-box-details`;
    try {
      const response = await axios.post(URL, data);
      return response;
    } catch (error) {
      return handleErrorResponse(error, rejectWithValue);
    }
  }
);

export const closeBin = createAsyncThunk(
  "closeBin",
  async (data, { rejectWithValue }) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/china/close-bin`;
    try {
      const response = await axios.post(URL, data);
      const labelUrl = response.data.label_url;
      const link = document.createElement("a");
      link.href = labelUrl;
      link.setAttribute("download", "bin_label.pdf"); 
       document.body.appendChild(link);
       link.click();
       link.remove();
      return response;
    } catch (error) {
      return handleErrorResponse(error, rejectWithValue);
    }
  }
);

export const scanSku = createAsyncThunk(
  "scanSku",
  async (data, { rejectWithValue }) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/qc/china/scan-sku`;
    try {
      const response = await axios.post(URL, data);
      return response;
    } catch (error) {
      return handleErrorResponse(error, rejectWithValue);
    }
  }
);

export const switchFacilityLoad = createAsyncThunk("switchFacilityLoad", async (data, { rejectWithValue }) => {
    const URL = `${process.env.REACT_APP_API_BASE_URL}v1/erp/switch-load-to-facility`;
    try {
      const response = await axios.post(URL, data);
      return response;
    } catch (error) {
      return handleErrorResponse(error, rejectWithValue);
    }
  }
);

